export default __webpack_public_path__ + "static/sx-ad04aab6d35979e0fdd81a796948ec06.svg";